import { render, staticRenderFns } from "./details_annules.vue?vue&type=template&id=7ad7ed77"
import script from "./details_annules.vue?vue&type=script&lang=js"
export * from "./details_annules.vue?vue&type=script&lang=js"
import style0 from "./details_annules.vue?vue&type=style&index=0&id=7ad7ed77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports